(function () {
  var PREV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var NEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';

  function init() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery || gallery.getAttribute('data-arrows')) return;
    var viewer = gallery.querySelector('slider-component');
    var list = gallery.querySelector('.product__media-list');
    if (!viewer || !list) return;

    function slideIds() {
      return [].map.call(list.querySelectorAll('.product__media-item'), function (li) { return li.getAttribute('data-media-id'); });
    }
    function thumbs() {
      var ids = slideIds();
      return [].filter.call(gallery.querySelectorAll('.thumbnail-list__item'), function (li) {
        return ids.indexOf(li.getAttribute('data-target')) !== -1;
      });
    }
    function current(items) {
      for (var i = 0; i < items.length; i++) {
        var b = items[i].querySelector('button');
        if (b && b.getAttribute('aria-current') === 'true') return i;
      }
      return 0;
    }

    var total = slideIds().length;
    if (total < 2) return;
    gallery.setAttribute('data-arrows', '1');

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'gallery-arrow gallery-arrow--prev';
    prev.setAttribute('aria-label', 'Anterior');
    prev.innerHTML = PREV;
    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'gallery-arrow gallery-arrow--next';
    next.setAttribute('aria-label', 'Siguiente');
    next.innerHTML = NEXT;
    viewer.appendChild(prev);
    viewer.appendChild(next);

    function update() {
      var items = thumbs();
      if (!items.length) return;
      var i = current(items);
      prev.disabled = i <= 0;
      next.disabled = i >= items.length - 1;
    }

    function go(dir) {
      var items = thumbs();
      if (items.length) {
        var j = current(items) + dir;
        if (j < 0 || j >= items.length) return;
        var btn = items[j].querySelector('button');
        if (btn) btn.click();
      } else {
        list.scrollBy({ left: dir * list.clientWidth, behavior: 'smooth' });
      }
      setTimeout(update, 50);
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });

    var thumbList = gallery.querySelector('.thumbnail-list');
    if (thumbList && window.MutationObserver) {
      new MutationObserver(update).observe(thumbList, { attributes: true, attributeFilter: ['aria-current'], subtree: true });
    }
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();